import clsx from 'clsx';
import styles from './Container.module.scss';

interface ContainerProps {
  children: React.ReactNode;
  size?: 'default' | 'compact' | 'tight' | 'max'; // TODO: Fix names and sizes and standardize across the project
  className?: string;
}

export const Container = ({ children, size = 'default', className }: ContainerProps) => (
  <div
    className={clsx(styles.container, className, {
      [styles.narrow]: size === 'compact',
      [styles.extraNarrow]: size === 'tight',
      [styles.max]: size === 'max',
    })}
  >
    {children}
  </div>
);
